import { PageHeader, PageLayout, Stack, Text } from "@softmax/design-system";

export function LeagueSettingsPending() {
  return (
    <PageLayout>
      <Stack width="auto">
        <PageHeader
          title="League settings"
          description="Rename a league you own."
        />
        <Text>Loading league settings…</Text>
      </Stack>
    </PageLayout>
  );
}
